import auth from '../../../config/app-specific-config/auth';
import * as types from './auth-integrations-action-types';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import { getUserProfile } from '../../profile/actions/users-profile-actions';
import { setUserPrivileges } from './auth-actions';


// Launchdeck version 
// export const launchdeckLogin = (email, password) => {
// 	return async dispatch => {
// 		dispatch(signOutClear());
// 		dispatch(loginRequest());
// 		try {
// 			const response = await axiosInstance.post('/user-sessions', {email, password});

// 			const { data } = response.data;
// 			const userSession = data.userSessions && data.userSessions[0];
// 			const userData = userSession && userSession.users[0];

// 			const {userType, token} = userSession || {};
// 			const {idToken} = userData || {};

// 			if (token) {
// 				const userPrivileges = data && data.userPrivileges;
// 		if (userPrivileges) {
// 			dispatch(setUserPrivileges(userPrivileges))
// 		}
// 				auth.storeToken(token);
// 				localStorage.setItem('USER_CATG', userType);  
// 				localStorage.setItem('USER_ID_TOKEN', idToken); 
// 				dispatch(getUserProfile({
// 					getOrgProfile: true
// 				}));
// 			} else if (response.data.data.isLoginError) {
// 				const {errorMessage} = response.data.data.errorPayload
// 				dispatch(loginFailure({
// 					isLoginError: true,
// 					errorMessage: errorMessage? errorMessage : 'We are unable to authenticate this email or password'
// 				}));
// 				// set error messages here
// 			} else {

// 				dispatch(loginFailure({
// 					isLoginError: true,
// 					errorMessage: 'We are unable to authenticate this email or password'
// 				}));
// 			}
// 			// auth.storeToken(data.userSessions[0].token);


// 			// Google Tag
// 			// window.gtag('config', 'G-ZRC2SM4PSB' , {'user_id': idToken});



// 			dispatch(loginSuccess(response));

// 		} catch (e) {
// 			if (e.message === 'Request failed with status code 500') {

// 				const loginFailureResponse = { 
// 					loginError: true,
// 					message: 'We are unable to authenticate this email or password'
// 				}
// 				dispatch(loginFailure(loginFailureResponse));
// 			} else if (e.message === 'Network Error') {
// 				dispatch(loginFailure(e.message));
// 				// throw new SubmissionError({
// 				// 	password: 'No connection to the network. Please try again later'
// 				// });
// 			}
// 		}
// 	}
// };


// Signup through external integrations actions
function integrationSignupRequest() {
	return {
		type: types.MANAGE_3P_INTEGRATION_SIGNUP_REQUEST
	};
}

function integrationSignupSuccess(response) {
	return {
		type: types.MANAGE_3P_INTEGRATION_SIGNUP_SUCCESS,
		payload: response
	};
}

function integrationSignupFailure(integrationSignupFailureResponse) {
	return {
		type: types.MANAGE_3P_INTEGRATION_SIGNUP_FAILURE,
		payload: integrationSignupFailureResponse
	};
}

export function manage3pIntegrationSignup(integrationSignupPayload) {
	return async dispatch => {
		dispatch(integrationSignupRequest());
		try {
			const header = auth.getContentType();
			const response = await axiosInstance.post('/users/integrations', integrationSignupPayload, header);
	
			if (response.data.data.eventProcessed) {
				switch (response.data.data.eventProcessed) {
					case ("login-existing-3p-integration-user"): {
						const { nextEvent, userSession, userPrivileges } = response.data.data || {};
						
						if (nextEvent === "login-existing-user") {
							const { token, user, userType } = userSession || {};
							const { idToken } = user || {};

							if (userPrivileges) {
								dispatch(setUserPrivileges(userPrivileges))
							}

							if (token) {
								auth.storeToken(token);
								userType && localStorage.setItem('USER_CATG', userType);
								idToken && localStorage.setItem('USER_ID_TOKEN', idToken);
								dispatch(getUserProfile({ getOrgProfile: true }));
							} else {
								// Show error
								console.log('UUU FE slack error')
							}

						} else if (nextEvent === "show-login-error") {
							// Show error
							console.log('UUU FE slack error')
						}
						break;
					}
					case ("create-3p-integration-user-account"): {
						const { nextEvent, userSession, userPrivileges } = response.data.data || {};

						if (nextEvent === "login-created-user") {
							const { token, user, userType } = userSession || {};
							const { idToken } = user || {};

							if (userPrivileges) {
								dispatch(setUserPrivileges(userPrivileges))
							}

							if (token) {
								auth.storeToken(token);
								userType && localStorage.setItem('USER_CATG', userType);
								idToken && localStorage.setItem('USER_ID_TOKEN', idToken);
								dispatch(getUserProfile({ getOrgProfile: true }));
							} else {
								// Show error
								console.log('UUU FE slack error')
							}
						} else if (nextEvent === "show-unsuccessful-create-user-outcome") {
								// Show error
								console.log('UUU FE slack error')

						}


						break;
					}
					default: {

						break;
					}
				}
			}
			// Logs in user
			// if (response.data.data.nextEvent === "log-in-and-redirect-to-homepage") {
			// 	if (response.data.data.userSession) {
			// 		// Logs in user
			// 		const {userType, token, userIdToken} = response.data.data.userSession || {};
			// 		const userPrivileges = response.data.data.userPrivileges;
// 		if (userPrivileges) {
// 			dispatch(setUserPrivileges(userPrivileges))
// 		}
			// 		if (token && userType && userIdToken) {
			// 			auth.storeToken(token);
			// 			localStorage.setItem('USER_CATG', userType);  
			// 			localStorage.setItem('USER_ID_TOKEN', userIdToken); 
			// 		}

			// 		delete response.data.data.userSession;

			// 		dispatch(getUserProfile({getOrgProfile: true}));
			// 	}
			// }

			dispatch(integrationSignupSuccess(response.data.data));
		} catch (error) {

			if (error.message === 'Request failed with status code 500') {
				const integrationSignupFailureResponse = {
					integrationSignupError: true,
					type: 'Account already exists',
					message: 'You may have registered for an account with this email address.'
				}
				dispatch(integrationSignupFailure(integrationSignupFailureResponse));

			} else if (error.message === 'Network Error') {
				const integrationSignupFailureResponse = {
					integrationSignupError: true,
					type: 'Network Error',
					message: 'Network connectivity issues detected. Please check your internet connection, and try again later.'
				}
				dispatch(integrationSignupFailure(integrationSignupFailureResponse));

			}
		}
	}
}


// Reset
export const integrationSignupReset = () => {
	return {
		type: types.MANAGE_3P_INTEGRATION_SIGNUP_RESET
	};
};

export function resetIntegrationSignup() {

	return async (dispatch) => {

		try {
			dispatch(integrationSignupReset());

		} catch (error) {
			dispatch(integrationSignupFailure(error));
		}
	};
}
